import React from 'react';
import {ButtonGroup, Dropdown, DropdownButton} from '@goproblems/ui';
import {useTranslation} from 'react-i18next';

interface SkipButtonProps {
    onSkipSession: () => void;
    onSkipForever: () => void;
    onSkipDuration: (duration: string) => void;
}

const SkipButton: React.FC<SkipButtonProps> = ({
    onSkipSession,
    onSkipForever,
    onSkipDuration,
}) => {
    const {t} = useTranslation();
    return (
        <>
            <DropdownButton
                as={ButtonGroup}
                variant="outline-secondary"
                title={t('skip.title')}
                id="skip-dropdown"
                align="end">
                <Dropdown.Item onClick={onSkipSession}>
                    {t('skip.this_session')}
                </Dropdown.Item>
                <>
                    <Dropdown.Divider />
                    <Dropdown.Item onClick={() => onSkipDuration('1_week')}>
                        {t('skip.one_week')}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => onSkipDuration('1_month')}>
                        {t('skip.one_month')}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => onSkipDuration('6_months')}>
                        {t('skip.six_months')}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => onSkipDuration('1_year')}>
                        {t('skip.one_year')}
                    </Dropdown.Item>
                    <Dropdown.Divider />
                </>
                <Dropdown.Item onClick={onSkipForever}>
                    {t('skip.forever')}
                </Dropdown.Item>
            </DropdownButton>
        </>
    );
};

export default SkipButton;
